<template>
  <el-card shadow="never">
    <a @click.prevent="handleClose" class="close">
      <i
        class="el-icon-error"
        style="font-size: 1.5em; color: #666; cursor: pointer; float: right; margin: -15px;"
      ></i>
    </a>
    <div class="elcard">
      <figure>
        <font-awesome-icon icon="file" style="font-size:4em;color:gray"/>
      </figure>
      <h2>File Name</h2>
      <p class="desc">{{fileInfo.objectKey}}</p>
      <div class="clearfix"></div>
      <ul class="card-detail">
        <li>
          <span>Package</span>
          <span>{{fileInfo.package}}</span>
        </li>
        <li>
          <span>Version Code</span>
          <span>{{fileInfo.versionCode}}</span>
        </li>
        <li>
          <span>Version Name</span>
          <span>{{fileInfo.versionName}}</span>
        </li>
        <li>
          <span>Size</span>
          <span>{{fileInfo.size}}</span>
        </li>
      </ul>
    </div>
  </el-card>
</template>

<script>
export default {
    props: ['fileInfo'],
    methods: {
        getDataFromChild () {
            return this.fileInfo
        },
        handleClose () {
            this.$emit('apkdelete', this.fileInfo.objectKey)
        }
    }
}
</script>

<style lang="scss" scoped>
.elcard {
    figure {
        float: left;
        margin: 15px 15px 0;
    }
    h2 {
        padding-top: 15px;
        display: inline-block;
        margin: 0;
        line-height: 1.5;
    }
    p.desc {
        margin: 0;
        line-height: 1;
    }

    ul.card-detail {
        margin: 0;
        padding-left: 15px;
        list-style: none;
        line-height: 2;
        li {
            margin: 0;
            padding: 0;
            width: 80%;
            span:first-child {
                display: inline-block;
                width: 150px;
                font-weight: bold;
            }
            border-bottom: 1px solid #ddd;
        }
    }
    .clearfix {
        clear: both;
    }
}
</style>
